var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 113,
    viewBox: "0 0 72 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9819 95.0189L20.5183 102.877C20.3504 102.92 20.1828 102.939 20.0178 102.939V108.403C20.0178 109.496 20.4523 110.545 21.2265 111.319C22.0008 112.094 23.0501 112.528 24.1433 112.528H47.8562C48.9508 112.528 50.0002 112.094 50.7744 111.319C51.5472 110.545 51.9819 109.496 51.9819 108.403V95.0189ZM51.9819 78.5672L20.5183 86.4253C20.3504 86.4666 20.1828 86.4871 20.0178 86.4871V98.7498L51.4829 90.8919C51.6493 90.8493 51.817 90.8301 51.9821 90.8301L51.9819 78.5672ZM51.9819 62.1154L20.5183 69.9735C20.3504 70.0148 20.1828 70.0353 20.0178 70.0353V82.2981L51.4829 74.4399C51.6493 74.3974 51.817 74.3781 51.9821 74.3781L51.9819 62.1154ZM51.9819 45.6636L20.5183 53.5217C20.3504 53.5631 20.1828 53.5835 20.0178 53.5835V65.845L51.4829 57.9871C51.6493 57.9458 51.817 57.9266 51.9821 57.9253L51.9819 45.6636ZM20.0176 49.3933L51.4827 41.5352C51.6491 41.4938 51.8168 41.4734 51.9819 41.4734V35.5804L20.0176 35.5804V49.3933Z",
    fill: "#FDEAE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0629 0.000206619V31.4556L67.3742 31.4556C69.6531 31.4556 71.5 29.6086 71.5 27.3298C71.5 21.3023 71.5 10.1533 71.5 4.12576C71.5 1.84695 69.6531 0 67.3742 0L38.0629 0.000206619ZM33.9373 0.000206619L4.62576 0.000206619C2.34695 0.000206619 0.5 1.84715 0.5 4.12597L0.5 27.33C0.5 29.6088 2.34695 31.4558 4.62576 31.4558L33.9371 31.4558L33.9373 0.000206619Z",
    fill: "#FDEAE5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord11);
export default __webpack_public_path__ + "static/media/accord_11.e8ee9232365460cfa3e232c68e8a29a0.svg";
export { ForwardRef as ReactComponent };